export default function VisionMission() {
  const values = [
    { icon: 'ri-lightbulb-line', text: 'الابتكار' },
    { icon: 'ri-team-line', text: 'التشاركية' },
    { icon: 'ri-heart-pulse-line', text: 'الأثر' },
    { icon: 'ri-leaf-line', text: 'الاستدامة' },
    { icon: 'ri-award-line', text: 'الاحترافية' }
  ];

  return (
    <section className="relative py-20 bg-white overflow-hidden">
      {/* Diagonal Top Edge */}
      <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-gray-50 to-transparent transform -skew-y-2 origin-top-left"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            الرؤية والرسالة والقيم
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Vision */}
          <div className="group bg-gradient-to-br from-[#FF6B6B]/5 to-[#FF8E53]/5 p-10 rounded-3xl border border-[#FF6B6B]/20 hover:shadow-xl transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-eye-line text-white text-4xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              الرؤية
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              أن نكون المنصة الرائدة في تمكين طلاب المستقبل ورواد الأعمال عبر بيئة عمل مبتكرة مدعومة من القطاع الخاص
            </p>
          </div>

          {/* Mission */}
          <div className="group bg-gradient-to-br from-[#FF6B6B]/5 to-[#FF8E53]/5 p-10 rounded-3xl border border-[#FF6B6B]/20 hover:shadow-xl transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-compass-line text-white text-4xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              الرسالة
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              توفير مساحة متكاملة تجمع بين العمل والتطوير والإلهام، تربط الشباب بالفرص والشركات بالمواهب
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-10">
            القيم الأساسية
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex lg:flex-wrap lg:justify-center gap-4 lg:gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-[#FFF5F3] px-4 py-4 lg:px-8 lg:py-6 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 flex flex-col lg:flex-row items-center gap-2 lg:gap-4 text-center lg:text-right"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-white text-2xl`}></i>
                </div>
                <span className="font-bold text-xl text-gray-900">
                  {value.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
